module.exports = __webpack_public_path__ + "static/media/aukrit.f1f7fc56.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/Pictures/pics/aukrit.jpeg
// module id = 128
// module chunks = 0